import Notification from '../../../../../../../../resources/js/notification'
import apiService from '../../../apiService'
const QUERIES_DEFAULT_VALUE = []
const TOTAL_DEFAULT_VALUE = {}

export default {
  namespaced: true,
  state: {
    queries: QUERIES_DEFAULT_VALUE,
    total: TOTAL_DEFAULT_VALUE,
    fetching: true
  },
  mutations: {
    setQueries (state, queries) {
      state.queries = queries || QUERIES_DEFAULT_VALUE
    },
    setTotal (state, total) {
      state.total = total || TOTAL_DEFAULT_VALUE
    }
  },
  actions: {
    fetch ({ state, commit }, { idParent, sengine, from, to }) {
      state.fetching = true
      commit('setQueries')
      commit('setTotal')

      apiService.getMoney(idParent, sengine, from, to)
        .then(response => {
          commit('setQueries', response.data.queries)
          commit('setTotal', response.data.total)
          window.vue.$emit('projectMoneyLoaded')

          state.fetching = false
        })
        .catch(() => {
          commit('setQueries')
          commit('setTotal')
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить отчет по деньгам.'
          })
        })
    }
  },
  getters: {
    getPeriodDates: state => sengine => {
      if (state.queries.length && state.queries[0].money[sengine]) {
        return Object.keys(state.queries[0].money[sengine])
      }

      return []
    },
    queriesFiltered: state => search => {
      return state.queries.filter((query) => query.txt.includes(search))
    },
    queriesFilteredAndPaginated: (state, getters) => (search, page, perPage) => {
      return getters.queriesFiltered(search).slice((page - 1) * perPage, page * perPage)
    },
    getQuery: state => id => {
      return state.queries.find((query) => query.id === id)
    },
    getQueryMoneyValue: (state, getters) => (id, sengine, date) => {
      const query = getters.getQuery(id)
      if (query) {
        return query.money[sengine][date]
      }

      return null
    },
    getQueryTotalValue: (state, getters) => (id, sengine) => {
      const query = getters.getQuery(id)
      if (query) {
        return query.total[sengine]
      }

      return null
    },
    getTotalValue: state => sengine => {
      if (Object.prototype.hasOwnProperty.call(state.total, sengine)) {
        return state.total[sengine]
      }

      return null
    }
  }
}
